<div class="side-bar">
  <h1 class="subtitle mb-1">Admin Dashboard</h1>
  <ul class="link-group">
    <a [routerLink]="['/admin/beheer-gebruikers']">
      <li class="link-item" routerLinkActive="active">
        Gebruikers
      </li>
    </a>
    <a [routerLink]="['/admin/beheer-activiteiten']">
      <li class="link-item" routerLinkActive="active">
        Activiteiten
      </li>
    </a>
    <a [routerLink]="['/admin/beheer-organisaties']">
      <li class="link-item" routerLinkActive="active">
        Organisaties
      </li>
    </a>
  </ul>
</div>
